export default __webpack_public_path__ + "a5aa963db7f6c53ac15fe770f00a55f2.png";